<div class="custom-dropzone">
  <ng-content select="[fileInput]"></ng-content>

  <div class="custom-dropzone__overlay">
    <ng-content select=".custom-dropzone-overlay"></ng-content>
  </div>
</div>
